import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import RippleCtaButton from "./RippleCtaButton";

interface IconButtonProps {
  icon: IconDefinition;
  onClick: () => void;
  ariaLabel: string;
  label: string;
  suppressRoundedClass?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  ariaLabel,
  label,
  suppressRoundedClass,
}) => {
  return (
    <RippleCtaButton
      aria-label={ariaLabel}
      onClick={() => {
        onClick();
      }}
      config={{
        bgColor: "var(--casedetails-submenu-bg-color)",
        textColor: "var(--casedetails-submenu-text-color)",
        borderColor: "",
        hoverBgColor: "var(--casedetails-submenu-hover-bg-color)",
        hoverTextColor: "var(--casedetails-submenu-hover-text-color)",
        hoverBorderColor: "",
        padding: "",
      }}
      suppressRoundedClass={suppressRoundedClass}
      className="flex p-4 px-8 items-center gap-2"
    >
      <FontAwesomeIcon className="size-5" icon={icon} />
      <span className="hidden md:flex">{label}</span>
    </RippleCtaButton>
  );
};

export default IconButton;
